module.exports = {}


//////////////////
// WEBPACK FOOTER
// C:/FHE/Support/support-react-application/translator/langs/de_DE/translations.json
// module id = ../../translator/langs/de_DE/translations.json
// module chunks = 0